import { AsyncPipe, CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FeedbackModule } from './feedback/feedback.module';
import { SharedModule } from './shared/shared.module';
import { StaticPagesModule } from './static-pages/static-pages.module';

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';

// import { AngularFireMessagingModule } from '@angular/fire/messaging';
// import { AngularFireDatabaseModule } from '@angular/fire/database';
// import { AngularFireAuthModule } from '@angular/fire/auth';
// import { AngularFireModule } from '@angular/fire';

import { environment } from '../environments/environment';
import { ErrorHandlerModule } from './@core/error-handler/error-handler.module';
import { ApplicationRoutes } from './@core/routes/application-routes.const';
import { CustomLoaderFactory } from './@core/services/custom-translate.service';
import { IdentityService, setIdentity } from './@core/services/identity.service';
import { initUnifiedToastr, UnifiedToastrService } from './@core/design/unified-toastr.service';
import { appLocaleFactory, registerAppLocales } from './@core/locale/app-locale';
import { AuthService } from './auth/auth.service';
import { HomeModule } from './home/modules/home.module';
import { AuthenticationFactory } from './factories/authentication.factory';
import { NotificationService } from './services/notification.service';
import { PaymentModule } from './payment/payment.module';
import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
registerAppLocales();

export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, "./assets/translate/", '.json')
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    FeedbackModule,
    HomeModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300,
    }),
    BrowserModule,
    ErrorHandlerModule,
    AppRoutingModule,
    NgxChartsModule,
    NgbModule,
    BrowserAnimationsModule,
    RouterModule,
    FormsModule,
    SharedModule,
    CommonModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: any) => CustomLoaderFactory(http,
          [{ prefix: "./assets/translate/", suffix: ".json" }, { prefix: ApplicationRoutes.Culture.TranslatePrefix, suffix: ApplicationRoutes.Culture.TranslateSuffix }]),
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireModule.initializeApp(environment.firebase),
    StaticPagesModule,
    PaymentModule
  ],
  exports: [
    NgbModule, SharedModule
  ],
  providers: [NotificationService, AsyncPipe, ToastrService,
    IdentityService,
    // Date/number pipes follow the language the page was loaded in (Arabic month names, Latin digits).
    { provide: LOCALE_ID, useFactory: appLocaleFactory },
    // {
    //   provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: setIdentity,
      deps: [IdentityService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initUnifiedToastr,
      deps: [UnifiedToastrService, Injector],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: AuthenticationFactory,
      deps: [AuthService],
      multi: true,
    }],
  bootstrap: [AppComponent]
})
export class AppModule {

}
